import React, { useState } from "react";
import PropertyCard from "./components/PropertyCard";
import IdentifyPortal from "./components/IdentifyPortal";
import ListOfChanges from "./components/ListOfChanges";
import { ReactComponent as LocationIcon } from "assets/icons/location.svg";
import { ReactComponent as RemoveIcon } from "assets/icons/delete.svg";
import SearchCardMiddle from "./components/SearchCardMiddle";
import useProperties from "hooks/useProperties";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import { formatCurrency } from "utils/formatNumber";
import RemoveWarningDialog from "components/Dialog/RemoveWarningDialog";
import LocationIntelligencePopup from "./components/LocationIntelligencePopup";
import { useNavigate } from "react-router-dom";

const SearchCard = ({
  isAddedBy,
  property,
  lastPropertyRef,
  isOrganisePage = false,
  isMapProperty = false,
}) => {
  const [searchCardHeight, setSearchCardHeight] = useState(473);
  const { setSelectedPropertyPopup, removeDiscardedProperty } = useProperties();
  const navigation = useNavigate();
  const [isDiscardedProperty, setIsDiscardedProperty] = useState(false);
  const [removeWarningPopupOpen, setRemoveWarningPopupOpen] = useState(false);

  // Remove discarded property
  const handleDeleteDiscardedProperty = async () => {
    try {
      setIsDiscardedProperty(false);
      setRemoveWarningPopupOpen(false);
      await removeDiscardedProperty(property._id);
    } catch (error) {
      setIsDiscardedProperty(true);
    }
  };

  return (
    <>
      {!isDiscardedProperty || isOrganisePage ? (
        <div
          ref={lastPropertyRef}
          className={`w-full flex overflow-hidden max-w-[1515px] relative max-h-fit lg:max-h-none lg:h-[${searchCardHeight}px] ${
            isMapProperty ? "" : "lg:border-[1px]"
          } border-[#CCCCCCF2] rounded-[14px] lg:pt-[27px] lg:pr-[19px] lg:pl-[26px] md:pb-[10px] lg:pb-[30px]  flex-col xl:flex-row items-center space-y-4 xl:space-y-0 xl:space-x-5`}
        >
          <PropertyCard
            property={property}
            isAddedBy={isAddedBy}
            isOrganisePage={isOrganisePage}
            setSearchCardHeight={setSearchCardHeight}
            isDiscardedProperty={isDiscardedProperty}
            setIsDiscardedProperty={setIsDiscardedProperty}
          />
          <SearchCardMiddle property={property} />
          <LocationIntelligencePopup property={property} />

          <div className="w-full xl:w-[28.21%] md:h-full">
            <IdentifyPortal property={property} />
            <ListOfChanges property={property} />
            <div
              onClick={() =>
                navigation(
                  `/property/${property?._id}?average_gross_yield=${property?.average_gross_yield}`
                )
              }
              className="w-full hidden cursor-pointer md:inline-flex bg-primary items-center justify-center space-x-[10px]  rounded-[8px] h-[38px] mt-[9px] hover:opacity-90 duration-300 ease-in-out"
            >
              <LocationIcon className="text-white" />
              <p className="text-white font-semibold text-[12px]">
                Apri Annuncio
              </p>
            </div>
          </div>
          {isMapProperty && (
            <CloseIcon
              onClick={() =>
                setSelectedPropertyPopup({ id: null, property: null })
              }
              className="absolute top-[10.5px] cursor-pointer text-primary fill-primary right-[10.5px] z-[1]"
            />
          )}
        </div>
      ) : (
        // Different ui for discarded property

        <div
          ref={lastPropertyRef}
          className={`w-full flex max-w-[1515px] relative max-h-fit lg:max-h-none lg:h-[${searchCardHeight}px] ${
            isMapProperty ? "" : "lg:border-[1px]"
          } border-[#CCCCCCF2]  rounded-[14px] lg:pt-[27px] lg:pr-[19px] lg:pl-[26px] lg:pb-[30px]  flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-5 justify-between`}
        >
          <div className="flex items-center space-x-[45px]">
            <h1 className="text-[16px] max-w-[432px] md:text-[20px] lg:text-[24px] font-bold text-black leading-[1.4] md:leading-[28px] lg:leading-[36px] -tracking-[0.24px] line-clamp-1">
              {property?.title}
            </h1>
            <h2 className="text-primary font-bold lg:text-[36px] text-[24px] -tracking-[1px] leading-[29px] lg:leading-[36px]">
              {formatCurrency(property.sale_price, property?.sale_currency)}
            </h2>
          </div>
          <div
            onClick={() => setRemoveWarningPopupOpen(true)}
            className="w-full md:w-[28.21%] cursor-pointer inline-flex bg-[#000000] items-center justify-center space-x-[10px]  rounded-[8px] h-[38px] mt-[9px] hover:opacity-90 duration-300 ease-in-out"
          >
            <RemoveIcon className="text-white stroke-white" />
            <p className="text-white font-semibold text-[12px]">
              Rimuovi dalla lista delle proprietà scartate
            </p>
          </div>
        </div>
      )}

      <RemoveWarningDialog
        warningText={`Vuoi rimuovere questa proprietà dalla lista delle proprietà scartate?`}
        isOpen={removeWarningPopupOpen}
        isClose={() => setRemoveWarningPopupOpen(false)}
        onClick={handleDeleteDiscardedProperty}
        buttonText2="Annulla"
      />
    </>
  );
};

export default SearchCard;
